import { useCallback } from "react";
import { createTicketStatus, listTicketStatuses } from "../service/CallCenterTickets";
import { useAsyncAction } from "./useAsyncAction";

export const useTicketStatuses = () => {
  const state = useAsyncAction([]);

  const list = useCallback(
    async () => state.run(() => listTicketStatuses()),
    [state]
  );
  const create = useCallback(
    async (payload) => state.run(() => createTicketStatus(payload)),
    [state]
  );

  return {
    ...state,
    list,
    create,
  };
};
